import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="No Rules Rules by Reed Hastings and Erin Meyer"
        desc="Netflix and the culture of reinvention"
        keyword="no rules rules, netflix, reed hastings, erin meyer, company culture, talent density"
        image="/images/books/no-rules-rules.jpg"
        pageType="book"
        author="Reed Hastings, Erin Meyer"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/no-rules-rules.jpg"
                alt="no rules rules reed hastings erin meyer engineering book"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                No Rules Rules
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Reed Hastings, Erin Meyer</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Reed Hastings, co-founder of Netflix, and Erin Meyer reveal the unconventional
                management philosophy behind one of the most innovative companies in the world.
                The book outlines how Netflix built a culture of freedom and responsibility by
                focusing on talent density, radical candor, and removing controls rather than
                adding them.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                From eliminating vacation policies and expense approvals to encouraging open
                dissent, the Netflix approach challenges many traditional assumptions about how
                to run engineering teams and organizations. For engineers and engineering leaders
                alike, this book sparks important conversations about trust, autonomy, and what
                it takes to build a high-performing culture.
              </p>
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
